
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50.5 50.499"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":".5"}},[_c('path',{attrs:{"d":"M50.25 2.424A2.176 2.176 0 0048.076.249H8.936a2.176 2.176 0 00-2.174 2.175v39.14a2.175 2.175 0 002.174 2.173h39.139a2.175 2.175 0 002.174-2.173z"}}),_c('path',{attrs:{"d":"M44.823 35.027L39.056 19.64a1.085 1.085 0 00-1.919-.218l-7.508 11.264-4.448-5.338a1.084 1.084 0 00-1.765.137l-5.726 9.542M20.901 15.459a3.256 3.256 0 10-3.256-3.256 3.257 3.257 0 003.256 3.256zM50.25 35.033H6.762"}}),_c('path',{attrs:{"d":"M6.762 9.009H2.42a2.171 2.171 0 00-2.171 2.17v36.9a2.171 2.171 0 002.171 2.17h36.9a2.171 2.171 0 002.171-2.17v-4.342"}})])])
          )
        }
      }
    